<script>
import MobileButtonToggle from "@/components/Mobile/ButtonToggle.vue";
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "Headers",
    components: { MobileButtonToggle },
    data: () => ({
        CONFIG,
        showMobileNavigation: false
    }),
    methods: {
        ToggleMobileNavigation: function() { this.showMobileNavigation = !this.showMobileNavigation; }
    }
};
</script>

<template>
    <div id="header">
        <div id="top" class="row">
            <div id="brand" class="base m-span">
                <div class="m-pad">
                    <a href="/mls-tracking" aria-label="Los Angeles County Registrar-Recorder/County Clerk">
                        <div class="m-margin-align-c">
                            <div class="base">
                                <img title="Los Angeles County RR/CC" alt="Los Angeles County RR/CC" src="@/assets/Images/CountySeal.png" width="60" height="60"/>
                            </div>
                            <div id="txt" class="base margin-l single">
                                <p>Los Angeles County</p>
                                <p><b>Registrar-Recorder/County Clerk</b></p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <!-- Responsive -->
            <div id="primary-nav" class="m-d-toggle right">
                <ul>
                    <li class="primary"><a href="https://www.lavote.gov" target="_blank" aria-label="Navigate to LA Vote">LAVote.gov</a></li>
                    <li class="primary"><a href="https://www.lavote.gov/about-us/about-us" target="_blank" aria-label="Navigate to About Us">About Us</a></li>
                    <li class="primary"><a href="https://www.lavote.gov/contact-us/contact-us" target="_blank" aria-label="Navigate to Contact Us">Contact Us</a></li>
                </ul>
            </div>
            <div id="m-primary-nav" class="m-toggle row">
                <div id="m-primary-nav-btn" class="table m-span">
                    <div class="base m-margin cursor-pointer" @click="ToggleMobileNavigation()">
                        <MobileButtonToggle/>
                    </div>
                </div>
                <div id="m-primary-nav-items" class="m-span" v-if="showMobileNavigation">
                    <ul>
                        <li><a href="https://www.lavote.gov" target="_blank">LAVote.gov</a></li>
                        <li><a href="https://lavote.gov/about-us-about-us" target="_blank">About Us</a></li>
                        <li><a href="https://www.lavote.gov/contact-us/contact-us" target="_blank">Contact</a></li>
                    </ul>
                </div>
            </div>

        </div>
        <div id="header-details" class="row">
            <div class="m-span">
                <span id="page-title">{{ CONFIG.projectName }}</span>
            </div>
        </div>
    </div>
    <div id="platform">
        <div id="desktop" class="hide"></div>
        <div id="mobile" class="hide"></div>
    </div>
</template>